import React, { useState } from "react";
import { createGateway } from "../services";
import { ScaleLoader } from "react-spinners";

interface Gateway {
    name: string;
    url: string;
    returnUrl: string;
    region: string;
}

interface CreateGatewayModalProps {
    openModal: boolean;
    setOpenModal: (openModal: boolean) => void;
    onCreated?: () => void;
}

export default function CreateGatewayModal({ openModal, setOpenModal, onCreated }: CreateGatewayModalProps) {
    const [formData, setFormData] = useState<Gateway>({
        name: "",
        url: "",
        returnUrl: "",
        region: "",
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log("Submitting Gateway:", formData);

        setLoading(true);
        createGateway(formData);

        if (onCreated) {
            onCreated();
        }

        setLoading(false);


        setOpenModal(false);
        setFormData({ name: "", url: "", returnUrl: "", region: "" });
    };

    return (
        <div>
            {/* Open modal button */}
            <button
                onClick={() => setOpenModal(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700"
            >
                Create Gateway
            </button>

            {/* Modal */}
            {openModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
                        <h2 className="text-xl font-semibold mb-4">
                            Create Payment Gateway
                        </h2>

                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full mt-1 p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Gateway URL
                                </label>
                                <input
                                    type="url"
                                    name="url"
                                    value={formData.url}
                                    onChange={handleChange}
                                    className="w-full mt-1 p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Return URL
                                </label>
                                <input
                                    type="url"
                                    name="returnUrl"
                                    value={formData.returnUrl}
                                    onChange={handleChange}
                                    className="w-full mt-1 p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Region
                                </label>
                                <input
                                    type="text"
                                    name="region"
                                    value={formData.region}
                                    onChange={handleChange}
                                    className="w-full mt-1 p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div className="flex justify-end gap-2">
                                <button
                                    type="button"
                                    onClick={() => setOpenModal(false)}
                                    className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                                >
                                    Cancel
                                </button>

                                {loading ? (
                                    <ScaleLoader color="#36d7b7" className="mx-auto" />
                                ) : (
                                    <button
                                        type="submit"
                                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                                    >
                                        Save
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
